module.exports = __webpack_public_path__ + "img/solution2-1.1d176c79.png";